import { display, flexWrap, listStyleType, twCls } from '@/style';
import { DayScheduleItem, ScheduleItem } from './DayScheduleItem';

const HOUR = 60;

export interface Schedule {
  [key: string]: { setPoint: number };
}

export interface DayScheduleProps {
  schedule: Schedule;
  onScheduleItemClick: (key: string) => void;
}

export const DaySchedule = ({ schedule, onScheduleItemClick }: DayScheduleProps) => {
  const slices = Object.entries(schedule)
    .map(([schedule, entry]) => {
      const cronParts = schedule.split(' ');
      return {
        startHour: cronParts[1],
        startMinute: cronParts[0],
        startTime: Number(cronParts[0]) + Number(cronParts[1]) * HOUR,
        setPoint: entry.setPoint,
        duration: 0,
        key: schedule,
        entry,
      };
    })
    .sort((a, b) => a.startTime - b.startTime)
    .reduce((agg, entry, index, list) => {
      entry.duration = (list[index + 1]?.startTime ?? 24 * HOUR) - entry.startTime;
      return [...agg, entry];
    }, [] as ScheduleItem[]);

  return (
    <div>
      <ul className={twCls(display('flex'), flexWrap('flex-nowrap'), listStyleType('list-none'))}>
        {slices.map((entry) => (
          <DayScheduleItem key={entry.key} item={entry} onItemClick={onScheduleItemClick} />
        ))}
      </ul>
    </div>
  );
};
